<template>
  <div class="row mb-1">
    <div id="grafik-sentimen" class="col-md-12 px-gap">
      <div class="card card-default shade">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="pull-left m-t-5 m-b-5">
                <h4 class="m-b-0">Grafik Sentimen</h4>
                <p class="small hint-text">Data Persentase dan Tren Sentimen</p>
              </div>
              <div class="pull-right m-t-20">
                <button class="btn btn-success mr-3" @click="getDataExcel">
                  <i class="bi bi-filetype-xlsx mr-1"></i> Ekspor Data
                </button>
                <div class="form-check form-check-inline switch">
                  <input
                    type="checkbox"
                    id="show-bar-sentimen"
                    v-model="show_bar_sentiment"
                  />
                  <label for="show-bar-sentimen">Tampilkan Grafik Bar</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-sm-12">
              <loader-component v-if="is_loading" />
              <div v-else>
                <div
                  v-if="
                    data_stats.netral == 0 &&
                      data_stats.positif == 0 &&
                      data_stats.negatif == 0
                  "
                  class="alert alert-danger"
                  id="errorApiEl"
                  role="alert"
                  align="center"
                >
                  <strong>Mohon maaf, data tidak tersedia! </strong>
                  <br />
                  Tidak dapat menampilkan grafik dengan data kosong.
                </div>
                <pie-chart-component v-else :data="data_stats" />
              </div>
            </div>
            <div class="col-md-9 col-sm-12">
              <loader-component v-if="is_loading" />
              <div v-else>
                <div
                  v-if="Object.keys(data_series).length === 0"
                  class="alert alert-danger"
                  id="errorApiEl"
                  role="alert"
                  align="center"
                >
                  <strong>Mohon maaf, data tidak tersedia! </strong>
                  <br />
                  Tidak dapat menampilkan grafik dengan data kosong.
                </div>
                <div v-else>
                  <line-chart-component
                    v-if="!show_bar_sentiment"
                    :series="data_series"
                    el="linechart-sentimen"
                    mode="single"
                  />
                  <div v-else>
                    <bar-chart-component :data="data_series" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import line_chart from "@/views/components/chart/line_chart.vue";
import pie_chart from "@/views/components/chart/pie_chart.vue";
import bar_chart_horizontal from "@/views/components/chart/bar_chart_horizontal.vue";
import loader_component from "@/views/components/loader.vue";
import XLSX from "xlsx";

export default {
  name: "persentase_tren_sentiment",
  components: {
    "line-chart-component": line_chart,
    "pie-chart-component": pie_chart,
    "bar-chart-component": bar_chart_horizontal,
    "loader-component": loader_component,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
    data: {
      type: Object,
      default: function() {
        return {};
      },
    },
    stats: Array,
  },
  data() {
    return {
      data_series: this.data,
      data_stats: this.stats,
      show_bar_sentiment: false,
      excel_fields: {
        Tanggal: "Tanggal",
        Positif: "Positif",
        Netral: "Netral",
        Negatif: "Negatif",
        Jumlah: "Jumlah Berita",
      },
      excel_data: [],
    };
  },
  methods: {
    getDataExcel: function() {
      for (let tanggal in this.data_series.x) {
        this.excel_data.push({
          Tanggal: this.data_series.x[tanggal],
          Positif: this.data_series.y[0].data[tanggal],
          Netral: this.data_series.y[1].data[tanggal],
          Negatif: this.data_series.y[2].data[tanggal],
          "Jumlah Berita":
            this.data_series.y[0].data[tanggal] +
            this.data_series.y[1].data[tanggal] +
            this.data_series.y[2].data[tanggal],
        });
      }
      this.$store.dispatch("loading", true);
      var topik = XLSX.utils.json_to_sheet(this.excel_data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, topik, "Topik");
      XLSX.writeFile(wb, "Sentimen.xlsx");
      this.$store.dispatch("loading", false);
    },
  },
};
</script>
